
import { Component, Vue } from 'vue-property-decorator'
import { getGoodsInfo, GoodsInfoDto, editGoodsSubmit } from '@/api/commodity'
import { Toast } from 'vant'

@Component
export default class coomdsPackage extends Vue {

  packageId = '617fb6a07b05020008398bed'
  goodsId = '617fb69e7b05020008398bea'
  companyId = '6194a03e003426000851d069'
  goodsInfo: GoodsInfoDto | Record<string, any> = {}
  packageStatus: true
  isSyncOther: false

  created () {
    this.companyId = this.$route.query.companyId as string
    this.goodsId = this.$route.query.goodsId as string
    this.packageId = this.$route.query.packageId as string

    this.getInfo()
  }

  getInfo () {
    getGoodsInfo({companyId: this.companyId, goodsId: this.goodsId, packageId: this.packageId}).then(res => {
      this.goodsInfo = res.data[0] || []
      this.goodsInfo.isSyncOtherBool = Number(this.goodsInfo.isSyncOther) === 1
    })
  }

  handleIsSyncOtherChange (item, index) {
    this.goodsInfo.isSyncOther = this.goodsInfo.isSyncOtherBool ? '1' : '0'
    this.$set(this.goodsInfo,'isSyncOther',this.goodsInfo.isSyncOther)
  }


  //按客户级别定价
  coomdsPrice () {
    this.$router.push({
      path: '/coomdsPrice',
      query: {
        companyId: this.companyId,
        goodsId: this.goodsId,
      }
    })
  }

  //按客户定价
  coomdsPrices () {
    this.$router.push({
      path: '/coomdsPrices',
      query: {
        companyId: this.companyId,
        goodsId: this.goodsId,
      }
    })
  }

  edatil () {
    (this.$refs.creatCompany as any).validate().then(() => {
      console.log(this.goodsInfo)
      editGoodsSubmit(this.goodsInfo).then(() => {
        this.$toast.success('保存成功')
        this.$router.back()
      })
    })
  }

}
